
<app-breadcrumb [updatedAt]="moment(experience.updatedAt).calendar()" [custom]="breadcrumb"></app-breadcrumb>
<div class="row">
    <div class="col-9 card-container">
        <app-card (onEditGroupOptions)="editGroupOptions($event)" [customHeader]="false" [backButtom]="node.groupId" (goToParentFolder)="backToParent()" [cardTitle]="node.title" [options]="false" [customOption]="{groupId: node.groupId, mapType: node.mapType}" *ngIf="node.interactions">

            <div class="actions-wrapper shadow">
                <div class="card-header-right d-flex align-items-center justify-content-start">
                <div (click)="setExpSegment('list')" class="px-2" [class.text-secondary]="expSegment === 'list'" [placement]="'top'" ngbTooltip="Vista elenco" tooltipClass="tooltip">
                    <i class="fal fa-list fa-lg"></i>
                </div>
                <div *ngIf="experience.hasPrizes" (click)="setExpSegment('prize')" class="px-2" [class.text-secondary]="expSegment === 'prize'" [placement]="'top'" ngbTooltip="Modifica premi" tooltipClass="tooltip">
                    <i class="fal fa-trophy fa-lg"></i>
                </div>
                <div *ngIf="experience.mapType !== 'disabled'" (click)="setExpSegment('map')" class="px-2" [class.text-secondary]="expSegment === 'map'" [placement]="'top'" ngbTooltip="Modifica mappa" tooltipClass="tooltip">
                    <i class="fal fa-map fa-lg"></i>
                </div>
                <div (click)="setExpSegment('edit')" class="px-2" [class.text-secondary]="expSegment === 'edit'" [placement]="'top'" ngbTooltip="Modifica Experience" tooltipClass="tooltip">
                    <i class="fal fa-cog fa-lg"></i>
                </div>
                </div>
            </div>

            <div id="tree" *ngIf="expSegment === 'list'">
                <ul class="folder-list sortableUl" [sortablejs]="node.interactions" [sortablejsOptions]="sortablejsOptions">
                    <li *ngFor="let item of node.interactions">
            
                        <!-- GROUP ITEM -->
                        <div *ngIf="item.nodeType === 'group'" class="d-flex align-items-center justify-content-start py-2" >
                            <i class="fal fa-folder fa-2x mr-2"></i>
                            <span (click)="openGroup(item.groupId)">{{item.title}}</span>
                            <div class="ml-auto mr-5 d-flex align-items-center justify-content-start" >
                                <!-- <div class="mr-3" [routerLink]="['/group', item.id]" [queryParams]="{ expPath: router.url}">
                                    <i class="fal fa-cog"></i>
                                </div> -->
                                <div (click)="deleteGroupModal.show(); groupId = item.groupId" [placement]="'top'" ngbTooltip="Elimina gruppo" tooltipClass="tooltip">
                                    <i class="fal fa-trash text-danger"></i>
                                </div>
                            </div>
                        </div>
                        <!-- INTERACTION ITEM -->
                        <div *ngIf="item.nodeType !== 'group'" class="d-flex align-items-center justify-content-start py-2">
                            <i class="fal fa-file fa-2x mr-2"></i>
                            <span>{{item.title}}</span>
                            <div class="ml-auto mr-5 d-flex align-items-center justify-content-start">
                                <div class="mr-3" [routerLink]="['/interactions/', item.interactionId]" [queryParams]="{ expPath: location.path(), tempExpId: experience.id , order: node.interactions.length ? node.interactions[node.interactions.length-1].order + 1 : 1}" [placement]="'top'" ngbTooltip="Modifica Interaction" tooltipClass="tooltip">
                                    <i class="fal fa-pencil"></i>
                                </div>
                                <div class="mr-3" (click)="getIntDetails(item.id)" [placement]="'top'" ngbTooltip="Opzioni Interaction" tooltipClass="tooltip">
                                    <i class="fal fa-cog"></i>
                                </div>
                                <div (click)="deleteInt(item.id)" [placement]="'top'" ngbTooltip="Rimuovi Interaction" tooltipClass="tooltip">
                                    <i class="fal fa-trash text-danger"></i>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>  
                <div ngbDropdown class="dropdown" [placement]="'bottom-left'">
                    <span class="text-primary btn btn-link p-0" id="addInteractionButton" ngbDropdownToggle>
                        <i class="fal fa-plus-circle fa-lg"></i>
                    </span>
                    <div ngbDropdownMenu aria-labelledby="addInteractionButton" class="dropdown-menu">
                        <span ngbDropdownItem (click)="createdInteractions.show()">Aggiungi una Interaction già creata</span>
                        <span ngbDropdownItem (click)="createNewInt()">Crea una nuova Interaction</span>
                        <span ngbDropdownItem (click)="addGroupModal.show()">Crea un nuovo gruppo</span>
                    </div>
                </div>
            </div>
        
            <div id="prize" *ngIf="expSegment === 'prize' && f('experienceForm').hasPrizes.value">
                <div class="col-sm-12" *ngIf="!prizes.length">
                    Non hai ancora creato nessun Prize.&nbsp;<a href="javascript:;" [routerLink]="['/prizes/new']">Crea il tuo primo Prize</a>
                </div>
                <div class="row" *ngIf="prizes.length">
                    <div class="col-sm-12">
                        <p>Seleziona i premi che desideri associare alla Experience e determina il punteggio necessario per sbloccarli.</p>
                        <small>Il punteggio massimo ottenibile in questa experience è {{maxPoints}}</small>
                    </div>
                    <div class="col-sm-12 mt-2 text-danger" *ngIf="maxPoints === 0">
                        <p>Per aggiungere un premio devi prima impostare assegnare i punti alle Interactions.<br/>
                        Naviga fino alla Interaction in cui vuoi aggiungere punti e clicca su <i class="fal fa-cog"></i> </p>
                    </div>
                    <div class="col-12 mt-3" *ngFor="let prize of prizes; let i = index;">
                        <div class="row bg-light p-3 mb-2 prize d-flex align-items-center" [class.active]="isPrizeActive(prize.id)">
                            <div class="col-2">
                                <img [src]="environment.imageCDN + environment.imageFolder + '/' + prize.image" class="img-fluid d-block mx-auto">
                            </div>
                            <div class="col-6">
                                <h4>{{prize.title}}</h4>
                                <p class="mb-0">{{prize.description}}</p>
                            </div>
                            <div class="col-3">
                                <input class="points" type="number" placeholder="0" (keyup)="setPrizePoints(prize.id, $event)" [value]="getPrizePoints(prize.id)"/>
                            </div>
                            <div class="col-1 button-wrapper" (click)="selectPrize(prize.id)" *ngIf="isPrizeActive(prize.id)">
                                <i class="fal fa-check text-primary fa-lg"></i>
                            </div>
                            <div class="col-1 button-wrapper" (click)="selectPrize(prize.id)" *ngIf="!isPrizeActive(prize.id)">
                                <i class="fal fa-plus-circle text-primary fa-lg"></i>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-sm-12 mt-3 d-flex justify-content-end">
                        <button type="button" class="btn btn-primary btn-confirm" [disabled]="!validatePrizesPoints()" (click)="setPrizesPoints()">SALVA</button>
                    </div>
                </div>
            </div>
        
            <div id="map" *ngIf="expSegment === 'map' && f('experienceForm').mapType.value === 'image'" >
                <div class="row">
                    <div class="col-12">
                        <app-image-map [interactionsOnMap]="getIntsOnMap('tree')" [imagePath]="experience.mapData?.imagePath" [interactions]="tree.interactions" (intsOnMapComplete)="setIntsOnMap($event)"></app-image-map>
                    </div>
                    <div class="col-sm-12 mt-3 d-flex justify-content-end">
                        <button type="button" class="btn btn-primary btn-confirm" [disabled]="!validateIntsOnMap()" (click)="saveExperience()">SALVA</button>
                    </div>
                </div>
            </div>

            <div id="edit" *ngIf="expSegment === 'edit'">
                <form action="javascript:;" [formGroup]="experienceForm">
                    <aw-wizard #wizard class="arc-wizard" navBarLocation="left">
            
                        <aw-wizard-step stepTitle="CONFIGURAZIONE">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label for="title">TITOLO*</label>
                                        <input formControlName="title" type="text" class="form-control" id="titolo" aria-describedby="titolo" placeholder="Titolo Experience">
                                        <small id="titleHelp" class="form-text text-muted">Scrivi un titolo che rappresenti la tua nuova Experience</small>
                                    </div>
                                    <div class="form-group">
                                        <label for="description">DESCRIZIONE AGGIUNTIVA*</label>
                                        <app-tinymce formControlName="description" id="descrizione" aria-describedby="descrizioneHelp"></app-tinymce>
                                        <small id="descriptionHelp" class="form-text text-muted">Scrivi una descrizione che rappresenti la tua nuova Experience</small>
                                    </div>
                                    <div class="form-group">
                                        <label for="info">INFO</label>
                                        <app-tinymce formControlName="info" id="info" aria-describedby="infoHelp"></app-tinymce>
                                        <small id="infoHelp" class="form-text text-muted">Inserisci le info della tua Experience</small>
                                    </div>
                                    <div class="form-group">
                                        <label for="tipologia">TIPOLOGIA</label>
                                            <div>
                                                <label class="md-check">
                                                <input type="radio" value="gioco" name="tipologia" formControlName="tipologia">
                                                Gioco
                                                </label>
                                                <label class="md-check ml-3">
                                                <input type="radio" value="itinerario" name="tipologia" formControlName="tipologia">     
                                                Itinerario
                                                </label>
                                            </div>
                                        <small id="tipologiaHelp" class="form-text text-muted">Seleziona la tipologia per la tua experience</small>
                                    </div>
                                    <div class="form-group">
                                        <label for="titolo">LINK VIDEO</label>
                                        <input formControlName="video" type="text" class="form-control" id="video" aria-describedby="videoHelp" placeholder="Link video">
                                        <small id="videoHelp" class="form-text text-muted">Aggiungi un link ad un video</small>
                                    </div>
                                </div>
                                <div class="col-sm-12 d-flex justify-content-end">
                                    <button type="button" class="btn btn-primary" awNextStep [disabled]="!validateConfigurazione()">Avanti</button>
                                </div>
                            </div>
                        </aw-wizard-step>
            
                        <aw-wizard-step stepTitle="ASPETTO">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>FEATURED IMAGE</label>
                                        <app-media-manager [filePath]="f('experienceForm').image.value" (onFileSelect)="setImageUrl($event, 'experienceForm','image')"></app-media-manager>
                                    </div>
                                    <div class="form-group">
                                        <label for="primaryColor">PRIMARY COLOR</label>
                                        <input formControlName="primaryColor"
                                                type="text"
                                                class="form-control"
                                                id="primaryColor"
                                                aria-describedby="primaryColorHelp"
                                                [(colorPicker)]="f('experienceForm').primaryColor.value"
                                                [style.background]="f('experienceForm').primaryColor.value"
                                                (colorPickerChange)="colorPickerPlaceholderLight(f('experienceForm').primaryColor.value)"
                                                [style.color]="pickerPlaceholderColor"
                                                [value]="f('experienceForm').primaryColor.value"
                                                [cpPosition]="'bottom'">
                                        <small id="primaryColorHelp" class="form-text text-muted">Inserisci un colore per la tua nuova Experience</small>
                                    </div>
                                </div>
                                <div class="col-sm-12 d-flex justify-content-end">
                                    <button type="button" class="btn btn-outline-primary mr-1" awPreviousStep>Indietro</button>
                                    <button type="button" class="btn btn-primary" awNextStep [disabled]="!validateAspetto()">Avanti</button>
                                </div>
                            </div>
                        </aw-wizard-step>
            
                        <aw-wizard-step stepTitle="ATTIVAZIONE">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label for="hasPeriod">PERIODO LIMITATO</label>
                                        <div class="switch m-r-10">
                                            <input formControlName="hasPeriod" type="checkbox" id="hasPeriod" aria-describedby="hasPeriodHelp">
                                            <label for="hasPeriod" class="cr"></label>
                                        </div>
                                        <small id="hasPeriodHelp" class="form-text text-muted">La tua Experience potrà essere disponibile solo in un periodo di tempo limitato?</small>
                                    </div>
                                    <div class="form-group" *ngIf="f('experienceForm').hasPeriod.value">
                                        <label for="periodo">PERIODO DI ATTIVAZIONE</label>
                                        <div class="horizontal-scroll">
                                            <ngb-datepicker 
                                                #dp
                                                [startDate]="fromDate"
                                                (dateSelect)="onDateSelection($event)"
                                                [displayMonths]="2"
                                                [dayTemplate]="t"
                                                id="periodo"
                                                aria-describedby="periodoHelp">
                                            </ngb-datepicker>
                                            <ng-template #t let-date="date" let-focused="focused">
                                                <span class="custom-day"
                                                        [class.focused]="focused"
                                                        [class.range]="isRange(date)"
                                                        [class.faded]="isHovered(date) || isInside(date)"
                                                        (mouseenter)="hoveredDate = date"
                                                        (mouseleave)="hoveredDate = null">
                                                    {{ date.day }}
                                                </span>
                                            </ng-template>
                                            <small id="periodoHelp" class="form-text text-muted">Seleziona il periodo nel quale vuoi che sia fruibile la tua Experience</small>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 d-flex justify-content-end">
                                    <button type="button" class="btn btn-outline-primary mr-1" awPreviousStep>Back</button>
                                    <button type="button" class="btn btn-primary" awNextStep [disabled]="!validatePeriodo()">Continue</button>
                                </div>
                            </div>
                        </aw-wizard-step>
            
                        <aw-wizard-step stepTitle="NAVIGAZIONE">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label for="fixedOrder">ORDINE INTERACTIONS</label>
                                        <div class="switch m-r-10">
                                            <input formControlName="fixedOrder" type="checkbox" id="fixedOrder" aria-describedby="fixedOrderHelp">
                                            <label for="fixedOrder" class="cr"></label>
                                        </div>
                                        <small id="fixedOrderHelp" class="form-text text-muted">Indica se le Interactions potranno essere fruibili in un ordine predefinito oppure scelto liberamente dall'utente.</small>
                                    </div>
                                    <div class="form-group">
                                        <label for="map">TIPOLOGIA DI MAPPA</label>
                                        <div class="switch-field">
                                            <input formControlName="mapType" type="radio" id="disabled" name="mapType" value="disabled" (click)="mapType = 'disabled'" checked/>
                                            <label for="disabled">Nessuna Mappa</label>
                                            <!-- <input formControlName="mapType" type="radio" id="geo" name="mapType" value="geo" (click)="mapType = 'geo'"/>
                                            <label for="geo">Mappa Geografica</label> -->
                                            <input formControlName="mapType" type="radio" id="image" name="mapType" value="image" (click)="mapType = 'image'"/>
                                            <label for="image">Mappa Immagine</label>
                                        </div>
                                        <small id="mapHelp" class="form-text text-muted">Di che tipo è la mappa della tua Experience?</small>
                                    </div>
                                    <div class="form-group" *ngIf="f('experienceForm').mapType.value === 'image'">
                                        <label>IMMAGINE MAPPA</label>
                                        <app-media-manager [filePath]="mapData?.imagePath" (onFileSelect)="setImageUrl($event, null)"></app-media-manager>
                                    </div>
                                </div>
                                <div class="col-sm-12 d-flex justify-content-end">
                                    <button type="button" class="btn btn-outline-primary mr-1" awPreviousStep>Back</button>
                                    <button type="button" class="btn btn-primary" awNextStep [disabled]="!validateNavigazione()">Continue</button>
                                </div>
                            </div>
                        </aw-wizard-step>
            
                        <aw-wizard-step stepTitle="PREMI">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label for="prizes">PRIZES</label>
                                        <div class="switch m-r-10">
                                            <input formControlName="hasPrizes" type="checkbox" id="prizes" aria-describedby="prizesHelp">
                                            <label for="prizes" class="cr"></label>
                                        </div>
                                        <small id="prizesHelp" class="form-text text-muted">La tua Experience prevede l'assegnazione di premi?</small>
                                    </div>
                                </div>
                                <div class="col-sm-12 d-flex justify-content-end">
                                    <button type="button" class="btn btn-outline-primary mr-1" awPreviousStep>Back</button>
                                    <button type="button" class="btn btn-primary" awNextStep (click)="saveExperience()">Salva</button>
                                </div>
                            </div>
                        </aw-wizard-step>
            
                    </aw-wizard>
                </form>
            </div>
        </app-card>
    </div>
    <div class="col-3">
        
            <!-- SIDEBAR-->
            <!-- <div class="row bg-dark p-2">
                <div class="col-9">
                    <h6 class="d-block text-white my-0">STATUS: <span class="text-primary text-uppercase">{{experience.status}}</span></h6>
                </div>
                <div class="col-3">
                    <div class="switch" style="margin-top:-14px;">
                        <input type="checkbox" id="status" (change)="changeExperienceStatus($event)" style="display:none;" [checked]="experience.status === 'online'">
                        <label for="status" class="cr"></label>
                    </div>
                </div>
            </div> -->
            <button class="btn btn-primary d-block w-100 my-3" data-modal="pubblica" (click)="validateExperience()" [innerHTML]="'PUBBLICA EXPERIENCE'"></button>
            <div class="">
                <p class="text-muted">
                        <b>Le tue modifiche sono state salvate come bozza.</b><br>
                        Ricordati di pubblicare per rendere le tue modifiche visibili agli utenti.
                </p>
            </div>
            <div class="text-center  mt-4">
                <a href="javascript:;" (click)="deleteModal.show()"><small class="text-danger">Elimina Experience</small></a>
            </div>
            <div class="text-center  mt-2" *ngIf="experience.alreadyPublished">
                <a href="javascript:;" (click)="resetModal.show()"><small class="text-warning">Ripristima ultima versione pubblicata</small></a>
            </div>
    </div>
</div>



    <h4 class="mb-5">ALBEROBELLO</h4>
    <ng-template #recursiveList let-list>
        <ul *ngFor="let item of list" class="invid-tree-item">
            <li>
                {{item.title}} - <small>order: {{item.order}}</small>
                <div *ngIf="item.interactions">
                    <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: item.interactions }"></ng-container>
                </div>
            </li>
        </ul>
    </ng-template>
    <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: node.interactions }"></ng-container>

    <app-ui-modal #pubblicaModal dialogClass="modal-dialog-centered">
        <div class="app-modal-header">
          <h5 class="modal-title">Vuoi Pubblicare?</h5>
          <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close" (click)="pubblicaModal.hide()"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="app-modal-body">
            <p>
                Sei davvero sicuro di voler pubblicare "{{experience.title}}"?<br/>
                <small>Pubblicando le modifiche verranno apportate alla Experience e sarà disponibile per gli utenti online.</small>
            </p>
        </div>
        <div class="app-modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="pubblicaModal.hide(); toastSavedAsDraft()">Salva come bozza</button>
          <button type="button" class="btn btn-primary" (click)="pubblicaModal.hide(); setExperienceToOnline()">Pubblica</button>
        </div>
    </app-ui-modal>

    <app-ui-modal #addGroupModal dialogClass="modal-dialog-centered">
        <div class="app-modal-header">
          <h5 class="modal-title">Nome del gruppo</h5>
          <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close" (click)="addGroupModal.hide();"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="app-modal-body">
            <input type="text" name="groupName" #groupName />
        </div>
        <div class="app-modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="addGroupModal.hide(); addGroup(groupName)">Aggiungi</button>
        </div>
    </app-ui-modal>

    <app-ui-modal #createdInteractions dialogClass="modal-dialog-centered">
        <div class="app-modal-header">
          <h5 class="modal-title">Seleziona l'interazione da aggiungere</h5>
          <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close" (click)="createdInteractions.hide()"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="app-modal-body">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="searchFilterDesc"><i class="fal fa-search"></i></span>
                </div>
                <input id="searchFilter" type="text" [(ngModel)]="searchFilter" [placeholder]="'Cerca'" class="form-control w-100" aria-describedby="searchFilterDesc">
            </div>
            <ul class="list-group list-group-flush mt-2">
                <li class="list-group-item interaction" *ngFor="let interaction of interactions | search:'title,description':searchFilter" [class.active]="interaction === selectedInt">
                    <app-interaction-list-item [interaction]="interaction" (click)="selectedInt = interaction"></app-interaction-list-item>
                </li>
            </ul>
        </div>
        <div class="app-modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="createdInteractions.hide(); addInteraction()" [disabled]="!selectedInt">Aggiungi</button>
        </div>
    </app-ui-modal>

    <app-ui-modal #onlineModal dialogClass="modal-dialog-centered">
        <div class="app-modal-header">
          <h5 class="modal-title">Vuoi rendere effettive le modifiche?</h5>
          <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close" (click)="onlineModal.hide()"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="app-modal-body">
            <p>
                Mettendo "{{experience.title}}" online tutte le modifiche apportate verranno rese effettive e pubblicate online.
            </p>
        </div>
        <div class="app-modal-footer">
          <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="onlineModal.hide(); f.status.setValue(false)">Annulla</button> -->
          <!-- <button type="button" class="btn btn-primary" (click)="onlineModal.hide(); this.saveExperience(true);">Applica modifiche e pubblica</button> -->
        </div>
    </app-ui-modal>

    <app-ui-modal #deleteModal dialogClass="modal-dialog-centered">
        <div class="app-modal-header">
          <h5 class="modal-title">Sicuro di voler eliminare la tua Experience?</h5>
          <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close" (click)="deleteModal.hide()"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="app-modal-body">
            <p>
                Eliminando "{{experience.title}}" perderai tutti i dati relativi alla Experience.
            </p>
        </div>
        <div class="app-modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="deleteModal.hide();">Annulla</button>
          <button type="button" class="btn btn-primary" (click)="deleteModal.hide(); this.deleteExperience();">Elimina</button>
        </div>
    </app-ui-modal>

    <app-ui-modal #deleteGroupModal dialogClass="modal-dialog-centered">
        <div class="app-modal-header">
          <h5 class="modal-title">Sicuro di voler eliminare il gruppo?</h5>
          <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close" (click)="deleteGroupModal.hide()"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="app-modal-body">
            <p>
                Eliminando il gruppo eliminerai anche tutti i contenuti al suo interno. Vuoi procedere all'eliminazione?
            </p>
        </div>
        <div class="app-modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="deleteGroupModal.hide();">Annulla</button>
          <button type="button" class="btn btn-primary" (click)="deleteGroupModal.hide(); deleteGroup(groupId)">Elimina</button>
        </div>
    </app-ui-modal>

    <app-ui-modal #resetModal dialogClass="modal-dialog-centered">
        <div class="app-modal-header">
          <h5 class="modal-title">Sicuro di voler ripristinare i dati della tua Experience?</h5>
          <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close" (click)="resetModal.hide()"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="app-modal-body">
            <p>
                Ripristinando "{{experience.title}}" perderai tutti i dati non pubblicati e tornerai all'utlima versione pubblicata.
            </p>
        </div>
        <div class="app-modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="resetModal.hide();">Annulla</button>
          <button type="button" class="btn btn-primary" (click)="resetModal.hide(); this.resetToOriginal();">Ripristina</button>
        </div>
    </app-ui-modal>

    <app-ui-modal #intDetailsModal dialogClass="modal-dialog-centered" [dialogClass]="'modal-lg'">
        <div class="app-modal-header">
          <h5 class="modal-title">Opzioni interazione</h5>
          <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close" (click)="intDetailsModal.hide()"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="app-modal-body">
            <aw-wizard #wizardIntDetal class="arc-wizard" navBarLocation="left" *ngIf="intDetailsOpened">
                <aw-wizard-step stepTitle="PUNTEGGIO">
                    <div class="row mb-3">
                        <div class="col-12"><label>PUNTI</label></div>
                        <div class="col-1"><i class="far fa-trophy"></i></div>
                        <div class="col-10"><input type="number" (keyup)="setIntDetails('points', $event)" [value]="intDetailsOpened?.points ? intDetailsOpened?.points : 0"/></div>
                        <div class="col-12"><small>Quanti punti ottiene chi completa l'interazione?</small></div>
                    </div>
                    <div class="col-sm-12 d-flex justify-content-end">
                        <button type="button" class="btn btn-primary" awNextStep>Avanti</button>
                    </div>
                </aw-wizard-step>
                <aw-wizard-step stepTitle="RISPOSTA ESATTA">
                    <div class="row mb-3">
                        <div class="col-12"><label>MESSAGGIO RISPOSTA ESATTA*</label></div>
                        <div class="col-1"><i class="far fa-smile"></i></div>
                        <div class="col-10"><input type="text" (keyup)="setIntDetails('rightAnswer', $event)" [value]="intDetailsOpened?.rightAnswer ? intDetailsOpened?.rightAnswer : null"/></div>
                        <div class="col-12"><small>Dai un messaggio all'utente nel caso in cui risponda correttamente</small></div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-12">
                            <div class="form-group mt-3">
                                <label class="d-block">IMMAGINE RISPOSTA CORRETTA</label>
                                <app-media-manager (onFileSelect)="setImageUrl($event, 'rightImage')" [filePath]="intDetailsOpened?.rightImage"></app-media-manager>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 d-flex justify-content-end">
                        <button type="button" class="btn btn-outline-primary mr-1" awPreviousStep>Indietro</button>
                        <button type="button" class="btn btn-primary" awNextStep >Avanti</button>
                    </div>
                </aw-wizard-step>
                <aw-wizard-step stepTitle="RISPOSTA SBAGLIATA">
                    <div class="row mb-3">
                        <div class="col-12"><label>MESSAGGIO RISPOSTA SBAGLIATA*</label></div>
                        <div class="col-1"><i class="far fa-frown"></i></div>
                        <div class="col-10"><input type="text" (keyup)="setIntDetails('wrongAnswer', $event)" [value]="intDetailsOpened?.wrongAnswer ? intDetailsOpened?.wrongAnswer : null"/></div>
                        <div class="col-12"><small>Dai un messaggio all'utente nel caso in cui risponda in modo errato</small></div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-12">
                            <div class="form-group mt-3">
                                <label class="d-block">IMMAGINE RISPOSTA SBAGLIATA</label>
                                <app-media-manager (onFileSelect)="setImageUrl($event, 'wrongImage')" [filePath]="intDetailsOpened?.wrongImage"></app-media-manager>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 d-flex justify-content-end">
                        <button type="button" class="btn btn-outline-primary mr-1" awPreviousStep>Indietro</button>
                        <button type="button" class="btn btn-primary" (click)="intDetailValid = true;" awNextStep >Avanti</button>
                    </div>
                </aw-wizard-step>
                <aw-wizard-step stepTitle="EXTRA">
                    <div class="row mb-3">
                        <div class="col-12 mt-3">
                            <div class="form-group">
                                <label for="tipologia">TIPOLOGIA</label>
                                    <div>
                                        <label class="md-check">
                                        <input type="radio" value="sito-attrattore" name="tipologia"  [(ngModel)]="intDetailsOpened.extra.type">
                                        Sito Attrattore
                                        </label>
                                        <label class="md-check ml-3">
                                        <input type="radio" value="consiglio-viaggio" name="tipologia"  [(ngModel)]="intDetailsOpened.extra.type">     
                                        Consiglio di viaggio
                                        </label>
                                        <label class="md-check ml-3">
                                        <input type="radio" value="tappa" name="tipologia"  [(ngModel)]="intDetailsOpened.extra.type">     
                                        Tappa
                                        </label>
                                        <label class="md-check ml-3">
                                        <input type="radio" value="nessuna" name="tipologia"  [(ngModel)]="intDetailsOpened.extra.type">     
                                        Nessuna
                                        </label>
                                    </div>
                                <small id="tipologiaHelp" class="form-text text-muted">Seleziona la tipologia per la tua experience</small>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label for="categoria">CATEGORIA</label>
                                <input id="categoria" class="form-control" type="text" [(ngModel)]="intDetailsOpened.extra.categoria"/>
                            </div>
                        </div>
                        <div class="col-sm-12 d-flex justify-content-end">
                            <button type="button" class="btn btn-outline-primary mr-1" awPreviousStep>Indietro</button>
                            <button type="button" class="btn btn-primary" awNextStep >Avanti</button>
                        </div>
                    </div>
                </aw-wizard-step>
                <aw-wizard-step stepTitle="TEMPO LIMITE">
                    <div class="row mb-3">
                        <div class="col-1"><i class="far fa-clock"></i></div>
                        <div class="col-10"><input type="text" (keyup)="setIntDetails('timeLimit', $event)" [value]="intDetailsOpened?.timeLimit ? intDetailsOpened?.timeLimit : 0"/></div>
                        <div class="col-12"><small>Inserisci il tempo massimo in secondi che gli utenti avranno a disposizione per poter risolvere la Interaction. Imposta 0 se non vuoi assegnare un limite di tempo.</small></div>
                    </div>
                    <div class="col-sm-12 d-flex justify-content-end">
                        <button type="button" class="btn btn-outline-primary mr-1" awPreviousStep>Indietro</button>
                    </div>
                </aw-wizard-step>
                
            </aw-wizard>
            
            
        </div>
        <div class="app-modal-footer">
          <button type="button" class="btn btn-primary" *ngIf="intDetailValid" (click)="intDetailsModal.hide(); saveIntDetails(intDetailsOpened); intDetailsOpened= null">Salva</button>
        </div>
    </app-ui-modal>

    <app-ui-modal #groupOptionsModal dialogClass="modal-dialog-centered" [dialogClass]="'modal-lg'">
        <div class="app-modal-header">
          <h5 class="modal-title">Opzioni Gruppo</h5>
          <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close" (click)="groupOptionsModal.hide()"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="app-modal-body">
            <aw-wizard #wizardGroupOptions class="arc-wizard" navBarLocation="left" *ngIf="currentGroup">
                <aw-wizard-step stepTitle="CONFIGURAZIONE">
                    <div class="row mb-3">
                        <div class="col-12"><label>TITOLO*</label></div>
                        <div class="col-12"><input type="text" [(ngModel)]="currentGroup.title"/></div>
                        <div class="col-12"><small>Dai un nome al gruppo</small></div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-12"><label>DESCRIZIONE</label></div>
                        <div class="col-12">
                            <app-tinymce  [(ngModel)]="currentGroup.description" ></app-tinymce>
                        </div>
                        <div class="col-12"><small>Descrizione del gruppo</small></div>
                    </div>
                    <div class="col-sm-12 d-flex justify-content-end">
                        <button type="button" class="btn btn-primary" [disabled]="!currentGroup.title || currentGroup.title === ''" awNextStep>Avanti</button>
                    </div>
                </aw-wizard-step>
                <aw-wizard-step stepTitle="EXTRA">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label for="info">INFO</label>
                                <app-tinymce [(ngModel)]="currentGroup.extra.info" id="info" aria-describedby="infoHelp"></app-tinymce>
                                <small id="infoHelp" class="form-text text-muted">Inserisci le info della tua Interazione</small>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label for="citta">CITTA'</label> città {{currentGroup.extra.citta}}
                                <input type="text" class="form-control" [(ngModel)]="currentGroup.extra.citta" id="citta" aria-describedby="cittaHelp">
                                <small id="cittaHelp" class="form-text text-muted">Inserisci La città e la provincia</small>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label for="tipologia">TIPOLOGIA</label>
                                    <div>
                                        <label class="md-check">
                                        <input type="radio" class="formControl" value="sito-attrattore" name="tipologia"  [(ngModel)]="currentGroup.extra.type">
                                        Sito Attrattore
                                        </label>
                                        <label class="md-check ml-3">
                                        <input type="radio" class="formControl" value="consiglio-viaggio" name="tipologia"  [(ngModel)]="currentGroup.extra.type">     
                                        Consiglio di viaggio
                                        </label>
                                        <label class="md-check ml-3">
                                        <input type="radio" class="formControl" value="tappa" name="tipologia"  [(ngModel)]="currentGroup.extra.type">     
                                        Tappa
                                        </label>
                                        <label class="md-check ml-3">
                                        <input type="radio" class="formControl" value="nessuna" name="nessuna" [checked]="!currentGroup.extra.type" [(ngModel)]="currentGroup.extra.type">     
                                        Nessuna
                                        </label>
                                    </div>
                                <small id="tipologiaHelp" class="form-text text-muted">Seleziona la tipologia per la tua experience</small>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label>CATEGORIA</label>
                                <input type="text" class="form-control" [(ngModel)]="currentGroup.extra.categoria"/>
                                <small>Assegna il gruppo ad una categoria</small>
                            </div>
                        </div>
                        <div class="col-12 mt-3">
                            <h6>Coordinate:</h6>
                                <div class="form-group">
                                    <label for="lat">LATITUDINE</label>
                                    <input type="text" class="form-control" id="lat" aria-describedby="latHelp" [(ngModel)]="currentGroup.extra.coordinates.lat" placeholder="41.89884227456026">
                                    <small id="latHelp" class="form-text text-muted">Inserisci la latitudine</small>
                                </div>
                                <div class="form-group">
                                    <label for="lat">LONGITUDINE</label>
                                    <input type="text" class="form-control" id="lng" aria-describedby="lngHelp" [(ngModel)]="currentGroup.extra.coordinates.lng" placeholder="12.52539241745996">
                                    <small id="lngHelp" class="form-text text-muted">Longitudine</small>
                                </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label for="video">VIDEO</label>
                                <input type="text" class="form-control" [(ngModel)]="currentGroup.extra.video" id="video" aria-describedby="videoHelp">
                                <small id="videoHelp" class="form-text text-muted">Inserisci il codice del video youtube</small>
                            </div>
                        </div>
                        <div class="col-sm-12 d-flex justify-content-end">
                            <button type="button" class="btn btn-primary" [disabled]="(currentGroup.extra.coordinates.lat && !currentGroup.extra.coordinates.lng) ||  (!currentGroup.extra.coordinates.lat && currentGroup.extra.coordinates.lng)" awNextStep>Avanti</button>
                        </div>
                    </div>
                </aw-wizard-step>
                <aw-wizard-step stepTitle="ASPETTO">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label>FEATURED IMAGE</label>
                                <app-media-manager [filePath]="currentGroup.image" (onFileSelect)="setImageUrl($event, 'group','image')"></app-media-manager>
                            </div>
                        </div>
                        <div class="col-sm-12 d-flex justify-content-end">
                            <button type="button" class="btn btn-outline-primary mr-1" awPreviousStep>Indietro</button>
                            <button type="button" class="btn btn-primary" awNextStep >Avanti</button>
                        </div>
                    </div>
                </aw-wizard-step>
                <aw-wizard-step stepTitle="NAVIGAZIONE">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label for="fixedOrder">ORDINE INTERACTIONS</label>
                                <div class="switch m-r-10">
                                    <input type="checkbox" [checked]="currentGroup.fixedOrder" (change)="currentGroup.fixedOrder = !currentGroup.fixedOrder" id="fixedOrder" aria-describedby="fixedOrderHelp">
                                    <label for="fixedOrder" class="cr"></label>
                                </div>
                                <small id="fixedOrderHelp" class="form-text text-muted">Indica se le Interactions potranno essere fruibili in un ordine predefinito oppure scelto liberamente dall'utente.</small>
                            </div>
                            <div class="form-group">
                                <label for="map">TIPOLOGIA DI MAPPA</label>
                                <div class="switch-field">
                                    <input type="radio" id="disabled" name="mapType" value="disabled" [checked]="currentGroup.mapType === 'disabled'" (click)="currentGroup.mapType = 'disabled'"/>
                                    <label for="disabled">Nessuna Mappa</label>
                                    <!-- <input type="radio" id="geo" name="mapType" value="geo"  [checked]="currentGroup.mapType === 'geo'"  (click)="currentGroup.mapType = 'geo'"/>
                                    <label for="geo">Mappa Geografica</label> -->
                                    <input type="radio" id="image" name="mapType" value="image" [checked]="currentGroup.mapType === 'image'"  (click)="currentGroup.mapType = 'image'"/>
                                    <label for="image">Mappa Immagine</label>
                                </div>
                                <small id="mapHelp" class="form-text text-muted">Di che tipo è la mappa del tuo gruppo?</small>
                            </div>
                            <div class="form-group" *ngIf="currentGroup.mapType === 'image'">
                                <label>IMMAGINE MAPPA</label>
                                <app-media-manager [filePath]="currentGroup.mapData?.imagePath" (onFileSelect)="setImageUrl($event, 'currentGroup')"></app-media-manager>
                            </div>
                        </div>
                        <div class="col-sm-12 d-flex justify-content-end">
                            <button type="button" class="btn btn-outline-primary mr-1" awPreviousStep>Back</button>
                            <button type="button" class="btn btn-primary" awNextStep [disabled]="!validateNavigazioneGruppi()" (click)="saveGroup()">SALVA</button>
                        </div>
                    </div>
                </aw-wizard-step>
                
            </aw-wizard>
        </div>
    </app-ui-modal>

    <app-ui-modal #groupMapModal dialogClass="modal-dialog-centered" [dialogClass]="'modal-lg'" (onModalClosed)="currentGroup = null">
        <div class="app-modal-header">
          <h5 class="modal-title">Mappa di {{currentGroup?.title}}</h5>
          <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close" (click)="groupMapModal.hide(); "><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="app-modal-body" *ngIf="currentGroup">
            <div class="row">
                <div class="col-12">
                    <app-image-map [interactionsOnMap]="getIntsOnMap('node')" [imagePath]="currentGroup.mapData?.imagePath" [interactions]="node.interactions" (intsOnMapComplete)="setIntsOnMap($event)" *ngIf="currentGroup"></app-image-map>
                </div>
                <div class="col-sm-12 mt-3 d-flex justify-content-end">
                    <button type="button" class="btn btn-primary btn-confirm" [disabled]="!validateIntsOnMap(true)" (click)="saveExperience();">SALVA</button>
                </div>
            </div>
        </div>
    </app-ui-modal>

<!-- <pre>
    {{currentGroup  | json}}
</pre> -->